import { useMemo, useState } from 'react';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardProspectsDIRTable from './DashboardProspectsDIRTable/DashboardProspectsDIRTable';
import { DashboardProspectsDIRFilters } from './DashboardProspectsDIR.types';
import { DashboardProspectsDIRContext } from './DashboardProspectsDIR.context';
import DashboardProspectsDIRFiltersModal from './DashboardProspectsDIRFiltersModal/DashboardProspectsDIRFiltersModal';
import { useDIRCommerciaux } from '../../../../../hooks/fetchers/useDIRCommerciaux/useDIRCommerciaux';
import DashboardProspectsDIRAssignModal from './DashboardProspectsDIRAssignModal/DashboardProspectsDIRAssignModal';
import { Prospect } from '../../../../../types/api/endpoints/prospect/prospect.types';
import CreateProspectDIRModal from './CreateProspectDIRModal/CreateProspectDIRModal';
import UploadExcelModal from './UploadExcelModal/UploadExcelModal';

export default () => {
  const { data: commerciaux } = useDIRCommerciaux();

  const [isFiltersModalOpen, setFiltersModalOpen] = useState(false);
  const [filters, setFilters] = useState<DashboardProspectsDIRFilters>({
    commercialIds: [],
  });

  const [isCreateModalOpen, setCreateModalOpen] = useState(false);

  const [isExcelModalOpen, setExcelModalOpen] = useState(false);

  const [isAssignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedProspect, setSelectedProspect] = useState<Prospect>();

  const contextValue = useMemo(
    () => ({
      isFiltersModalOpen,
      setFiltersModalOpen,
      filters,
      setFilters,
      isCreateModalOpen,
      setCreateModalOpen,
      isExcelModalOpen,
      setExcelModalOpen,
      isAssignModalOpen,
      setAssignModalOpen,
      selectedProspect,
      setSelectedProspect,
      commerciaux,
    }),
    [
      isFiltersModalOpen,
      setFiltersModalOpen,
      filters,
      setFilters,
      isCreateModalOpen,
      setCreateModalOpen,
      isExcelModalOpen,
      setExcelModalOpen,
      isAssignModalOpen,
      setAssignModalOpen,
      selectedProspect,
      setSelectedProspect,
      commerciaux
    ]
  );

  return (
    <DashboardProspectsDIRContext.Provider value={contextValue}>
      <DashboardLayout>
        <DashboardProspectsDIRTable />
        <DashboardProspectsDIRFiltersModal
          isOpen={isFiltersModalOpen}
          setOpen={setFiltersModalOpen}
        />
        <CreateProspectDIRModal 
          isOpen={isCreateModalOpen}
          setOpen={setCreateModalOpen}
        />
        <UploadExcelModal 
          isOpen={isExcelModalOpen}
          setOpen={setExcelModalOpen}
        />
        <DashboardProspectsDIRAssignModal 
          isOpen={isAssignModalOpen}
          setOpen={setAssignModalOpen}
        />
      </DashboardLayout>
    </DashboardProspectsDIRContext.Provider>
  );
};
